import React, { Component } from "react";
import PropTypes from "prop-types";
import { GUIDES_TAB_BAR_SLUG, GUIDES_TAB_HEADER_COLOR, GUIDES_TITLE_NAME } from "../../../helpers/constants";

import gpdWomanTable from "../../../assets/images/guides/GPD_woman_table_left.png";
import GuidesHeader from "../../../components/molecules/GuidesHeader";
import urlPatterns from "../../../urls";
import { header } from "../../../styles/variables";
import GuidesTabNavigator from "../../../components/molecules/GuidesTabNavigator";
import { executeGhostApi } from "../../../helpers/ghost";
import StyledLoading from "../../../components/atoms/Loading/StyledLoading";
import GuidesGlossaryPostsMain from "../../../components/molecules/GuidesTabPages/GuidesGlossaryPostsMain";

class GuidesTabTastingGlossary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    if (slug) {
      this.fetchPosts(slug);
    }
  }

  async componentDidUpdate(prevProps) {
    const { match } = this.props;
    const { params } = match || {};
    const { slug } = params || {};
    const previousSlug =
      prevProps && prevProps.match && prevProps.match.params && prevProps.match.params.slug;
    if (slug && previousSlug && previousSlug !== slug) {
      this.fetchPosts(slug);
    }
  }

  /**
   * Fetches posts from Ghost CMS using specific tag's slug.
   *
   * @param {String} slug
   * */
  fetchPosts = async (slug) => {
    this.setState({ loading: true });
    const posts = await executeGhostApi(slug);
    this.setState({ posts, loading: false });
  };

  /**
   * Gets title of page.
   *
   * @returns {Object}
   * */
  getTitleDetails = () => {
    const { posts } = this.state;
    const { match } = this.props;
    const { params } = match || {};
    const { slug } = params || {};

    let title = null;
    let glossaryDescription = null;

    posts.forEach((post) => {
      // CASE: Get title for header.
      if (post && post.primary_tag && post.primary_tag.slug === slug) {
        title = post.primary_tag.name;
      } else {
        const { excerpt } = post || {};
        glossaryDescription = excerpt;
      }
    });

    return { title, glossaryDescription };
  };

  render() {
    const { match, history, location } = this.props;
    const { url } = match || {};

    const { loading, posts } = this.state;

    if (loading) return <StyledLoading />;

    const { title, glossaryDescription } = this.getTitleDetails();

    return (
      <>
        <GuidesHeader
          headerIcon={gpdWomanTable}
          headerColor={GUIDES_TAB_HEADER_COLOR.GUIDE_TASTING}
          headerTitle={title || GUIDES_TITLE_NAME.GUIDE_TASTING}
          headerDescription={glossaryDescription}
        />
        <GuidesTabNavigator
          mobileHeaderStyleTop={header.mobileHeight}
          shouldDisappearOnMobile
          backgroundColor={GUIDES_TAB_HEADER_COLOR.GUIDE_TASTING}
          urlTasting={url}
          location={location}
        />
        <GuidesGlossaryPostsMain
          history={history}
          match={match}
          posts={posts}
          parentLabel="Tasting Guides"
          parentUrl={urlPatterns.GUIDE_TASTING}
          parentHomeSlug={GUIDES_TAB_BAR_SLUG.GUIDE_TASTING}
          isFromTabTasting
          location={location}
        />
      </>
    );
  }
}

GuidesTabTastingGlossary.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default GuidesTabTastingGlossary;
